'use client';

import { useGeo } from '../GeoProvider/hook';
import { RecapListProps, RecapListSection } from './index';

export const GeoRecapList = (props: RecapListProps) => {
  const { regionCode } = useGeo();

  return <RecapListSection {...props} state={regionCode} />;
};
